import { AuthManager } from "@bytescale/sdk"
import Cookies from "js-cookie"

import useRouter from "@hooks/useRouter"

import isModKeyPressed from "@utils/isModKeyPressed"

import { AUTH_ROUTES } from "@routes/auth"
import { SETTINGS_ROUTES } from "@routes/settings"

import { AUTH_ENDPOINTS } from "@endpoints/auth"

import { SETTINGS_PREVIOUS_PAGE } from "@constants/storage"

import useLocalStorage from "./useLocalStorage"

export default function useUserNavigationUtils() {
    const router = useRouter()

    const [, setPreviousPage] = useLocalStorage<string | null>(SETTINGS_PREVIOUS_PAGE, null)

    const logout = async () => {
        const logoutEndpoint = AUTH_ENDPOINTS.LOGOUT

        const headers = new Headers()
        headers.append("X-CSRFToken", Cookies.get("csrftoken") ?? "")
        headers.append("Accept", "application/json")
        headers.append("Content-Type", "application/json")

        try {
            await AuthManager.endAuthSession()
        } catch (error) {
            console.warn("Unable to end Bytescale auth session:", error)
        }

        try {
            await fetch(logoutEndpoint, { method: "POST", headers: headers })
            router.push(AUTH_ROUTES.AUTH)
        } catch (error) {
            console.error("Error logging out", error)
        }
    }

    const openHelpCenter = () => {
        window.Productlane.open("DOCS")
    }

    const openChangelog = () => {
        window.Productlane.open("CHANGELOG")
    }

    const openRequestFeature = () => {
        window.Productlane.open("FEEDBACK")
    }

    const openContactSupport = () => {
        window.Fernand("open")
    }

    const goToProfile = (event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement, MouseEvent>) => {
        setPreviousPage(router.pathname)
        if (!isModKeyPressed(event)) {
            event.preventDefault()
            router.push(SETTINGS_ROUTES.profile)
        }
    }

    const goToSettings = (event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement, MouseEvent>) => {
        setPreviousPage(router.pathname)
        if (!isModKeyPressed(event)) {
            event.preventDefault()
            router.push(SETTINGS_ROUTES.main)
        }
    }

    return {
        logout,
        openHelpCenter,
        openChangelog,
        openRequestFeature,
        openContactSupport,
        goToProfile,
        goToSettings,
    }
}
